(function(){
    function initVideoV2(block) {
        const btn = block.querySelector('.bnr-video__play'); 
        if (! btn) {
          return;
        }
        const video = block.querySelector('[data-type="mp4"] video');  
        if (! video) {
          return;
        }
        let videoPaused = video.paused;
        btn.addEventListener('click', function(event){ 
          event.preventDefault();
          event.stopPropagation();
          if (videoPaused) {             
            video.play();
            btn.classList.add('bnr-video__play--active');
          } else { 
            video.pause();
            btn.classList.remove('bnr-video__play--active');         
          }
          videoPaused = !videoPaused;
        });
    }
    document.addEventListener("DOMContentLoaded", (event) => {
        const blocks =  document.querySelectorAll('.bnr-video');
        for(let i = 0; i < blocks.length; i++) {
        initVideoV2(blocks[i]); 
        }
    });
})();